import PublicLayout from './layouts/PublicLayout'
import Landing from './pages/Landing'
import Features from './pages/Features'
import Products from './pages/Products'
import ProductCheckout from './pages/ProductCheckout'
import QuoteRequest from './pages/QuoteRequest'
import QuoteSuccess from './pages/QuoteSuccess'
import OrderSuccess from './pages/OrderSuccess'
import About from './pages/About'
import Contact from './pages/Contact'
import PaymentSuccess from './pages/PaymentSuccess'
import Privacy from './pages/legal/Privacy'
import Terms from './pages/legal/Terms'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import { BLOG_POSTS } from './data/blogPosts'

export const routes = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <Landing /> },
      { path: 'features', element: <Features /> },
      { path: 'products', element: <Products /> },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <Contact /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'terms', element: <Terms /> },
      { path: 'blog', element: <Blog /> },
      {
        path: 'blog/:slug',
        element: <BlogPost />,
        getStaticPaths: () => BLOG_POSTS.map((post) => `/blog/${post.slug}`),
      },
      // Transactional pages: reachable client-side but excluded from prerender (noindex)
      { path: 'product-checkout', element: <ProductCheckout />, entry: 'src/pages/ProductCheckout.jsx' },
      { path: 'quote-request', element: <QuoteRequest />, entry: 'src/pages/QuoteRequest.jsx' },
      { path: 'quote-success', element: <QuoteSuccess />, entry: 'src/pages/QuoteSuccess.jsx' },
      { path: 'order-success', element: <OrderSuccess />, entry: 'src/pages/OrderSuccess.jsx' },
      { path: 'payment/success', element: <PaymentSuccess />, entry: 'src/pages/PaymentSuccess.jsx' },
    ],
  },
]
